const currencies = [
  {
    value: "GBP",
    label: "£",
  },
  {
    value: "USD",
    label: "$",
  },
  {
    value: "EUR",
    label: "€",
  },
];

export default currencies;
